import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { mockData } from '../mock';

const Hero = () => {
  return (
    <section className="px-6 sm:px-12 lg:px-20 pt-28 sm:pt-32 pb-16 sm:pb-20">
      <div className="max-w-4xl w-full mx-auto">
        
        {/* Very Small, Elegant Intro Text - Refined and Minimal */}
        <div className="text-center mb-6 sm:mb-8 space-y-3 sm:space-y-4">
          {/* Extremely small, discreet intro */}
          <p className="text-xs sm:text-sm font-light text-black/70 leading-relaxed max-w-xl mx-auto px-4">
            {mockData.brand.hero}
          </p>
          
          {/* Minimal divider */}
          <div className="w-10 h-px bg-black/20 mx-auto"></div>
          
          {/* Tiny location */}
          <p className="text-[7px] sm:text-[8px] tracking-[2px] uppercase text-black/30 font-light">
            {mockData.brand.location}
          </p>
        </div>

        {/* HERO IMAGE - Immediate Focus, No Extra Space */}
        <div className="relative max-w-md lg:max-w-lg mx-auto mb-8 sm:mb-10">
          <div className="aspect-[3/4] bg-white border border-black/5 overflow-hidden shadow-sm">
            <img
              src={mockData.heroImage}
              alt="Laura Gonzalez Artistry"
              className="w-full h-full object-cover hover:scale-[1.02] transition-transform duration-700"
            />
          </div>
          {/* Subtle frame - desktop only */}
          <div className="hidden sm:block absolute -bottom-3 -right-3 w-full h-full border border-black/8 -z-10"></div>
        </div>

        {/* Compact CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 items-center justify-center">
          <Link
            to="/contact"
            className="inline-flex items-center justify-center gap-3 px-10 py-3.5 border border-black text-black text-[9px] sm:text-[10px] tracking-[2px] uppercase font-light hover:bg-black hover:text-white transition-all duration-300 group"
          >
            Get in Touch
            <ArrowRight size={14} strokeWidth={1} className="group-hover:translate-x-1 transition-transform" />
          </Link>
          
          <Link
            to="/portfolio"
            className="inline-flex items-center gap-2 text-[9px] sm:text-[10px] tracking-[2px] uppercase font-light text-black border-b border-black pb-1 hover:opacity-60 transition-opacity"
          >
            View Portfolio
            <ArrowRight size={14} strokeWidth={1} />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Hero;
